export const EVALUATION_MONTHS = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
export const EVALUATION_PERIODS = { monthly: "شهري", semester: "فصلي", annual: "نهاية العام الدراسي", range: "من تاريخ إلى تاريخ" };

export function evaluationPeriodText(period) {
  if (!period) return "تقييم سابق — لم تُحدد له فترة";
  if (period.kind === "monthly") {
    const [year, month] = period.month.split("-");
    return `شهري: ${EVALUATION_MONTHS[Number(month) - 1]} ${year}م`;
  }
  if (period.kind === "semester") return `الفصل الدراسي ${period.semester === "first" ? "الأول" : "الثاني"} — العام ${period.academic_year}هـ`;
  if (period.kind === "annual") return `نهاية العام الدراسي ${period.academic_year}هـ`;
  return `من ${period.start_date} إلى ${period.end_date} (ميلادي)`;
}
